// src/integrations/monta/manifest.js
import logo from './logo.svg';

const montaManifest = {
  slug: 'monta',
  type: 'Integrations::MontaIntegration',
  displayName: 'Monta',
  asset_sync_message: 'Sync imports charge points from your Monta account. You can also link one manually by numeric charge point ID (e.g. 5264363).',
  logo,
  colorClass: 'bg-white',
};

export default montaManifest;
